export const getSchemaWithConstants = (schema, constants) => {
  const properties = Object.entries(schema.Root.properties).reduce((acc, [propertyName, propertySchema]) => {
    if (propertySchema.constant) {
      // Récupération de la valeur de la constante (peut être un chemin comme "CONTRAT.EN_COMPTE")
      const constantValue = propertySchema.constant
        .split(".")
        .reduce((acc, key) => acc?.[key], constants);
      
      if (Array.isArray(constantValue)) {
        // Si c'est un tableau, on transforme les valeurs pour le select
        acc[propertyName] = {
          ...propertySchema,
          values: constantValue.map(value => ({
            value: value.id,
            description: value.name,
          })),
        };
      } else {
        // Si ce n'est pas un tableau, on laisse la propriété inchangée
        acc[propertyName] = propertySchema;
      }
    } else {
      // Pour les propriétés sans constante, on les laisse inchangées
      acc[propertyName] = propertySchema;
    }
    return acc;
  }, {});

  return {
    ...schema,
    Root: {
      ...schema.Root,
      properties,
    },
  };
};
